export default __webpack_public_path__ + "static/media/check-success.7311a16c.svg";